import { Link } from 'react-router-dom';
import { articles } from '@/mocks/data';

const featuredIds = [1, 2, 3];

export default function FeaturedArticles() {
  const featured = articles.filter((a) => featuredIds.includes(a.id));

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 mb-10 md:mb-14">
          <div>
            <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-3">
              育儿知识
            </span>
            <h2 className="font-heading text-2xl md:text-4xl text-foreground-950">
              精选育儿文章
            </h2>
          </div>
          <Link
            to="/category"
            className="text-sm text-primary-600 hover:text-primary-700 font-medium flex items-center gap-1 whitespace-nowrap cursor-pointer"
          >
            查看全部文章
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {featured.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden hover:border-background-300 transition-all cursor-pointer"
            >
              <div className="relative w-full h-44 overflow-hidden">
                <img
                  src={article.coverImage}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-0.5 rounded-full bg-background-50/90 backdrop-blur-sm text-xs font-medium text-foreground-700">
                    {article.categoryName}
                  </span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="font-heading text-base text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-foreground-600 text-sm leading-relaxed line-clamp-2 mb-3">{article.excerpt}</p>
                <div className="flex items-center justify-between text-xs text-foreground-500">
                  <span>{article.date}</span>
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    {article.readTime}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}